// src/Components/NaturalQuery/utils.ts

export const formatCurrency = (value: string | number): string => {
  const numValue = parseFloat(value.toString());
  if (isNaN(numValue)) return 'R$ 0,00';
  return `R$ ${numValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatDate = (dateStr: string): string => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return date.toLocaleDateString('pt-BR');
};

export const formatMonthName = (month: number, year: number): string => {
  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];
  return `${monthNames[month - 1]} de ${year}`;
};

export const getEmptyMessage = (dataType: string): string => {
  const messages: { [key: string]: string } = {
    'sellers': 'Não foram encontradas vendas de funcionários para este período. Verifique se há vendas registradas ou tente outro período.',
    'products': 'Nenhum produto foi encontrado com os critérios especificados. Verifique se há produtos cadastrados ou ajuste sua pesquisa.',
    'monthly': 'Não há dados de faturamento para o período consultado. Verifique se existem vendas registradas neste período.',
    'payments': 'Nenhuma forma de pagamento encontrada para este período. Verifique se há transações registradas.',
    'financial': 'Não foram encontradas receitas ou despesas para este período. Verifique se há lançamentos financeiros cadastrados.',
    'general': 'Não foram encontrados dados para sua consulta. Tente reformular a pergunta ou verificar se há informações cadastradas no sistema.'
  };
  return messages[dataType] || messages['general'];
};

export const suggestedQueries = [
  "Me informe o funcionário que mais vendeu no mês de abril de 2025",
  "Me mostra o faturamento dos últimos 3 meses",
  "Top 10 produtos que mais vendi em abril",
  "Valor das minhas despesas em abril de 2025",
  "Faturamento por formas de recebimento em abril",
  "Produtos que menos vendi este mês"
];